import CircleIcon from "@mui/icons-material/Circle";
import { Box, Tooltip } from "@mui/material";
import { useMemo } from "react";
import { ReadyState } from "react-use-websocket";
import { theme } from "@/theme/theme";
import { WS_CONNECTION_STATUS } from "../hooks/use-websocket";

export const WebSocketStatusIcon = ({ readyState }: { readyState: ReadyState }) => {
  const name = WS_CONNECTION_STATUS[readyState];

  const { color, tokenColor, animation } = useMemo(() => {
    switch (readyState) {
      case ReadyState.CONNECTING:
        return {
          color: theme.palette.warning.main,
          tokenColor: "warning.main",
          animation: "pulseGlow 1.5s ease-in-out infinite",
        };
      case ReadyState.OPEN:
        return {
          color: theme.palette.success.main,
          tokenColor: "success.main",
          animation: "pulseGlow 2s ease-in-out infinite",
        };
      case ReadyState.CLOSING:
        return {
          color: theme.palette.warning.main,
          tokenColor: "warning.main",
          animation: "pulseGlow 1s ease-in-out infinite",
        };
      case ReadyState.CLOSED:
        return {
          color: theme.palette.error.main,
          tokenColor: "error.main",
          animation: undefined,
        };
      case ReadyState.UNINSTANTIATED:
        return {
          color: theme.palette.grey[500],
          tokenColor: "grey.500",
          animation: undefined,
        };
      default:
        return {
          color: theme.palette.grey[500],
          tokenColor: "grey.500",
          animation: undefined,
        };
    }
  }, [readyState]);

  return (
    <Tooltip title={name}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "24px",
          height: "24px",
        }}
      >
        <CircleIcon
          fontSize="small"
          sx={{
            color: tokenColor,
            fontSize: "12px",
            animation,
            "@keyframes pulseGlow": {
              "0%": {
                opacity: 1,
                filter: `drop-shadow(0 0 1px ${color})`,
              },
              "50%": {
                opacity: 0.75,
                filter: `drop-shadow(0 0 2px ${color}) drop-shadow(0 0 3px ${color})`,
              },
              "100%": {
                opacity: 1,
                filter: `drop-shadow(0 0 1px ${color})`,
              },
            },
          }}
        />
      </Box>
    </Tooltip>
  );
};
